export default function Recur(props) {
  const options = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric'
  };

  const self = {
    matches: (orderId) => {
      return props.payments.find((payment) => payment.orderId == (orderId + ''))
    },
    createdAtFormatted: new Intl.DateTimeFormat('en-US', options).format(new Date(props.createdAt))
  }
  return Object.assign({}, props, self)
}
